import type { CustomCellRendererProps } from "ag-grid-react";
import { TriggerButton, TriggerButtonIntent, TriggerButtonSize } from "widgets";

// This cell is specific to the synteny viewer, therefore it's located on this folder
const NavigationCell = ({
  value: id,
  onNavigationCellClick,
}: CustomCellRendererProps & { onNavigationCellClick: (id: number) => void }) => {
  return (
    <TriggerButton
      icon="arrow_forward"
      intent={TriggerButtonIntent.Active}
      label="Navigate"
      onPress={() => onNavigationCellClick(id)}
      size={TriggerButtonSize.Small}
    />
  );
};

export const RendererCellForNavigation = ({
  onNavigationCellClick,
}: {
  onNavigationCellClick: (id: number) => void;
}) => {
  const WrappedRenderer = (props: CustomCellRendererProps) => (
    <NavigationCell {...props} onNavigationCellClick={onNavigationCellClick} />
  );
  WrappedRenderer.displayName = `RendererNavigationCell`;

  return WrappedRenderer;
};
